import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, Ticket } from "lucide-react";
import { showError } from "../../utils/alerts";
import AuthService from "../../services/Auth/auth.service";
import Input from "../../components/ui/Input";
import FormHeader from "../../components/ui/Form/FormHeader";
import FormButton from "../../components/ui/Form/FormButton";
import AuthLayout from "../../components/layout/AuthLayout";
import "./style.scss";

export default function Login() {
  const inputEmailRef = useRef(null);
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await AuthService.signInWithEmail(userEmail, password);
      navigate("/");
    } catch (e) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    inputEmailRef.current?.focus();
  }, []);

  return (
    <AuthLayout
      panelTitle="Inteligência em experiência do beneficiário."
      panelDescription="Plataforma de pesquisa contínua que mede a satisfação do beneficiário em 11 etapas da jornada e usa IA (persona Eva) para identificar drivers de atrito e oportunidades em linguagem natural."
    >
      <form className="auth__form" onSubmit={handleSubmit}>
        <FormHeader
          title="Bem-vindo à sua plataforma CX."
          description="A experiência do beneficiário em um só lugar."
        />
        <Input
          ref={inputEmailRef}
          name="email"
          label="E-mail corporativo"
          type="email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          placeholder="seu.nome@unimed.coop.br"
          autoComplete="email"
          required
        />

        <Input
          name="password"
          label="Senha"
          value={password}
          placeholder="••••••••••••"
          type={showPassword ? "text" : "password"}
          onChange={(e) => setPassword(e.target.value)}
          showPassword={showPassword}
          setShowPassword={setShowPassword}
          autoComplete="current-password"
          required
        />

        <button
          type="button"
          className="login__forgot-password"
          onClick={() => navigate("/forgot-password")}
        >
          Esqueci minha senha
        </button>

        <FormButton
          text="Entrar"
          isLoading={loading}
          loadingText="Autenticando..."
          icon={<ChevronRight size={16} strokeWidth={2.5} />}
        />

        <div className="login__voucher">
          <Ticket size={16} className="login__voucher-icon" />
          <span>
            Tem um voucher?
            <button
              type="button"
              className="login__voucher-link"
              onClick={() => navigate("/register")}
            >
              Crie sua conta aqui
            </button>
          </span>
        </div>

        <div className="login__contact">
          Não possui a plataforma?{" "}
          <a
            href="https://api.whatsapp.com/send/?phone=5521920268319&text&type=phone_number&app_absent=0"
            target="_blank"
            rel="noopener noreferrer"
            className="login__contact-link"
          >
            Entre em contato e agende uma demo
          </a>
        </div>
      </form>
    </AuthLayout>
  );
}
